import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const leoneldConfig: TSPConfig = {
  key: 'leoneld',
  name: 'Leon ELD',
  imageName: 'LeonELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your Leon ELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default leoneldConfig;
